import * as React from 'react';
import createSVGIcon from '../utils/createSVGIcon';

export default createSVGIcon(() => {
  return (
    <>
      <path d="M256 0A259 259 0 0 0 0 262c0 116 73 215 175 250 13 2 18-6 18-13l-1-49c-71
      16-86-31-86-31-12-30-28-38-28-38-24-17 1-16 1-16 26 2 40 27 40 27 22 40 59 28 74 22
      2-17 9-29 16-36-57-6-116-29-116-129 0-29 10-52 26-71-3-6-11-33 3-69 0 0 21-7 70 27a240
      240 0 0 1 128 0c49-34 70-27 70-27 14 36 6 63 3 69 16 19 26 42 26 71 0 101-60 123-117 129
      10 8 18 24 18 49l-1 72c0 7 5 15 18 13a262 262 0 0 0 175-250C512 118 397 0 256 0"/>
      <path d="M97 377c-1 1-3 2-4 1l-3-4c1-2 3-2 5-1s3 3 2 4M107 389c-1 1-3 0-5-1-2-2-2-5-1-6
      2-1 4-1 6 1 1 2 2 5 0 6M117 404c-1 1-4 0-5-2-2-3-2-6 0-7 1-1 4 0 5 3 2 2 2 5 0 6M131 418c-1
      2-4 2-6-1-3-2-3-5-2-6 2-2 5-1 7 1s3 5 1 6M150 427c0 2-3 3-6 2s-5-3-4-5c0-2 3-3 6-2 3 0 5 3 4
      5M171 428c0 3-2 4-5 4-3 1-6-1-6-3 0-3 3-4 6-4s5 1 5 3M191
      425c0 2-2 4-5 5s-6-1-6-3 2-4 5-5c3 0 5 1 6 3"/>
    </>
  );
}, '0 0 512 512');
